import { useMemo } from "react";

import { Invoice, Location } from "../../../redux/apis/types";
import { useSelector } from "react-redux";
import { State } from "../../../redux/root-reducer";

export const useFilterInvoice = (
  invoices: Invoice[],
  search: string[],
  locationId?: number
) => {
  const { locations } = useSelector((state: State) => state.Clients);

  let location: Location | undefined;
  if (locationId) {
    location = locations.find((item) => item.id === locationId);
  }
  const filter = useMemo(() => {
    let copy = [...invoices];

    for (let i = 0; i < search.length; i++) {
      // console.log("searchhhhh : ", search);
      copy = copy.filter(
        (item) =>
          item.data?.description
            ?.toLowerCase()
            .includes(search[i]?.toLowerCase()) ||
          item.data?.totalIncl
            ?.toLowerCase()
            .includes(search[i]?.toLowerCase()) ||
          item.invoice_number.toString().includes(search[i]?.toLowerCase()) ||
          item.data?.description
            ?.toString()
            .includes(search[i]?.toLowerCase()) ||
          item?.branch?.name
            ?.toLowerCase()
            .includes(search[i]?.toLowerCase()) ||
          item?.subcontractor?.name
            ?.toLowerCase()
            .includes(search[i]?.toLowerCase()) ||
          item.data.work.some((workItem) =>
            (workItem as any)?.planning?.location?.name
              ?.toLowerCase()
              .includes(search[i]?.toLowerCase())
          ) ||
          item.data.work.some((workItem) =>
            (workItem as any)?.locationName
              ?.toLowerCase()
              .includes(search[i]?.toLowerCase())
          ) ||
          item.data.work.some((workItem) =>
            (workItem as any)?.planning?.branch?.name
              ?.toLowerCase()
              .includes(search[i]?.toLowerCase())
          )
      );
    }

    if (location) {
      copy = copy.filter((item) =>
        item.data.work.some(
          (workItem) =>
            (workItem as any)?.locationName
              .split(" / ")[0]
              ?.toLowerCase()
              ?.includes(location?.name?.toLowerCase()) ||
            (workItem as any)?.equipment?.service
              ?.toLowerCase()
              ?.includes(location?.name?.toLowerCase())
        )
      );
    }

    return copy.map((item) => ({
      ...item,
      key: item.id,
    }));
  }, [invoices, search]);

  return filter;
};
